import * as Yup from 'yup';

const SigninSchema = Yup.object().shape({
  password: Yup.string().required('required.password'),
  passwordConfirmation: Yup.string().required('required.passwordConfirmation'),
});

export default SigninSchema;
